var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBreadcrumbSpacer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_641_2120",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_641_2120",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB2klEQVR4nO3dQUobURzH8SzqoouC4CkEj+DK0xRx1wPkABIRpob3SwK/VVeeRAOWnsBNwV6guCmtRFwUF87ERN5P3vcDs33zhy9vJpAZZjQCAAAAAAAAAKxP0o6kE0nfSinn8/l8/xXLYBu6rtuTdCXp33/Hb0mHWzkB1otRSvn+LMbjUUq5XmMpvGWMpyB/Nj4JthPj6bgduBy2cM+46Ymx2iGfNzoR+tnelbTsiyFpMmA5bIIYQczOyGFi5DAxcpgYOUyMHCZGDhMjh4mRw8TIYWLkMDFymBg5TIwcJkYOEyOHiZHDxMhhYuQwMXKYGDlMjBwmRg5iBCFGEGIEIUaQxWLxaeCDz6e1Z21CKeWCGEFKKb94Cj2IpLueS9VZ7RmbIukrl6wg3NRDf/au3ngdsFPOas/aDKIEIkogogQy95Q8JkoeEyWPiZLHRMljouQxUfKYKHlMlDwmSh4TJY+J8n4fIyr8n0KUppmdksdEyWOi5DFR8pgoeUyUPCZKHhMlj4mSx0R5v5+rkHRce9ZmdMM+6PKz9pxN6fo/efR3PB5/qD1nU7qXPwr2o/Z8Ld9Tls9i3M9ms6PaszVrMpl8lPRF0uXqzeDpdHpQeyYAAAAAAAAAGK3rAbSXBWW24ftHAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadcrumbSpacer);
export default __webpack_public_path__ + "static/media/breadcrumb-spacer.54db094b46a7b1a554923adfd911b092.svg";
export { ForwardRef as ReactComponent };